import { object, string } from "yup";

export const DECLINE_REASON_CATEGORIES = {
	CAPACITY_OVER: "capacity_over",
	OTHER: "other",
	OUT_OF_AREA: "out_of_area",
	PRICE_DISAGREEMENT: "price_disagreement",
	SCHEDULE_MISMATCH: "schedule_mismatch"
} as const;

export const DECLINE_REASON_OPTIONS = [
	{
		label: "対応エリア外のため",
		value: DECLINE_REASON_CATEGORIES.OUT_OF_AREA
	},
	{
		label: "個社マニュアルの単価・運用について不合意のため",
		value: DECLINE_REASON_CATEGORIES.PRICE_DISAGREEMENT
	},
	{
		label: "キャパシティオーバーのため",
		value: DECLINE_REASON_CATEGORIES.CAPACITY_OVER
	},
	{
		label: "入居者の退去立会希望日程と合わないため",
		value: DECLINE_REASON_CATEGORIES.SCHEDULE_MISMATCH
	},
	{
		label: "その他",
		value: DECLINE_REASON_CATEGORIES.OTHER
	}
] as const;

export type AnswerType = "accept" | "decline";

export type PartnerAssignmentFormValues = {
	answerType: AnswerType;
	declineReasonCategory: string;
	declineReasonDetail: string;
};

export type UpdateParams = {
	answerType: AnswerType;
	declineReasonCategory: string;
	declineReasonDetail: string;
};

export const partnerAssignmentResponseSchema = object().shape({
	answerType: string()
		.required("回答を選択してください")
		.oneOf(["accept", "decline"], "回答を選択してください"),
	declineReasonCategory: string().when("answerType", {
		is: "decline",
		// biome-ignore lint/suspicious/noThenProperty: Yupのwhen/then構文のため
		then: (schema) => schema.required("対応不可理由を選択してください")
	}),
	declineReasonDetail: string()
		.max(1000, "詳細理由は1,000文字以内で入力してください")
		.when("declineReasonCategory", {
			is: DECLINE_REASON_CATEGORIES.OTHER,
			// biome-ignore lint/suspicious/noThenProperty: Yupのwhen/then構文のため
			then: (schema) => schema.required("詳細理由を入力してください")
		})
});
